import React, { Suspense } from 'react';
import { Switch, BrowserRouter } from 'react-router-dom';
import Charting from '../screens/Charting';
import Component from '../screens/Component';
import ComponentMulti from '../screens/ComponentMulti';
import Home from '../screens/Home';
import DesktopWL from '../screens/DesktopWL';

const NotFound = React.lazy(() => import('./../screens/NotFound'));
const SignInCallBack = React.lazy(() => import('./../screens/SignInCallBack'));

export default function() {
  return (
    <Suspense fallback={null}>
      <BrowserRouter>
        <Switch>
          <SignInCallBack exact path="/signin-callback" />
          <DesktopWL exact path="/screen/:name" />
          <Charting exact path="/charting" />
          <Component path="/:name" />
          <NotFound exact status={404} />
        </Switch>
      </BrowserRouter>
    </Suspense>
  );
}
